import React from "react";

export const Chevron: React.FC = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1000 1000">
      <path d="M864.2 244.4c28.8-28.5 75.4-28.5 104.2 0 28.8 28.5 28.8 74.7 0 103.2l-416.3 408c-28.8 28.5-75.5 28.5-104.3 0l-416.2-408c-28.8-28.5-28.8-74.7 0-103.2s75.4-28.5 104.2 0L500 579l364.2-334.6z" />
    </svg>
  );
};
